/* global axios */
import ApiClient from './ApiClient';

// SiteUp (Lia Imobiliária): sugestão de imóveis no Copilot. POST por conversa,
// source 'lia' (inventário próprio) ou 'todas' (radar). Gated no backend pela
// feature flag 'imoveis_suggestion'.
class ImoveisAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  suggest({
    conversationId,
    source,
    page = 1,
    filters = null,
    reextract = false,
  }) {
    return axios.post(`${this.url}/${conversationId}/property_suggestions`, {
      source,
      page,
      filters,
      reextract,
    });
  }

  // Ficha do lead para imprimir (Módulo Imobiliária). Nada é gravado: cada
  // chamada relê a conversa e o inventário.
  generateLeadSheet(conversationId) {
    return axios.post(`${this.url}/${conversationId}/lead_sheet`);
  }
}

export default new ImoveisAPI();
